angular.module('myappointments').controller('ConfirmAppointmentCtrl',
    ['$scope', '$q', 'ListService', 'MyAppointmentsService',
        function ($scope, $q, ListService, MyAppointmentsService) {
            'use strict';

            $scope.loading = true;

            $scope.appointment = {
                CalendarDescription: '',
                AppointmentTypeDescription: '',
                AppointmentName: '',
                RequestDateTime: null,
                Reason: '',
                AppointmentType: { Id: ''}
            };

            $scope.appointmentLocation = {
                Id: '',
                Name: '',
                GoogleMapsUrl: '',
                Address1: '',
                Address2: '',
                City: '',
                State: '',
                Zip: '',
                PhoneNumber: ''
            };


            function loadPage() {
                var calendarList = ListService.getList('calendar', $scope, 'calendars');
                var serviceSiteList = ListService.getList('servicesite', $scope, 'serviceSites');
                var appointmentTypeList = ListService.getList('appointmenttype', $scope, 'appointmentType');

                $q.all([calendarList, serviceSiteList, appointmentTypeList]).then(function () {
                    var requestedAppointment = MyAppointmentsService.getRequestedAppointment();

                    var appointmentType = _.find($scope.appointmentType, {Id: requestedAppointment.AppointmentType.Id});
                    $scope.appointment.AppointmentTypeDescription = appointmentType.Description;
                    $scope.appointment.AppointmentTypeName = appointmentType.Name;
                    $scope.appointment.RequestDateTime = requestedAppointment.RequestDateTime;
                    $scope.appointment.Reason = requestedAppointment.Reason;
                    $scope.appointment.CalendarDescription = requestedAppointment.Calendar.Description;

                    var selectedCalendar = _.find($scope.calendars, {Id: requestedAppointment.Calendar.Id});
                    var serviceSite = _.find($scope.serviceSites, {Id: selectedCalendar.DefaultServiceSiteId});
                    selectAppointmentLocation(serviceSite);

                    MyAppointmentsService.clearRequestedAppointment();
                    $scope.loading = false;
                });

            }
            loadPage();


            function selectAppointmentLocation(serviceSite) {
                if (serviceSite) {
                    $scope.appointmentLocation.Id = serviceSite.Id;
                    $scope.appointmentLocation.Name = serviceSite.Description;
                    $scope.appointmentLocation.Address1 = serviceSite.Address.Address1;
                    $scope.appointmentLocation.Address2 = serviceSite.Address.Address2;
                    $scope.appointmentLocation.City = serviceSite.Address.City;
                    $scope.appointmentLocation.State = serviceSite.Address.State;
                    $scope.appointmentLocation.Zip = serviceSite.Address.Zip;
                    $scope.appointmentLocation.PhoneNumber = serviceSite.PhoneNumber.PhoneNumber;
                    $scope.appointmentLocationDefined = true;
                }
            }

        }]);